import React, { useEffect, useState } from 'react';

// UI Components (from React Bootstrap)
import { Card, Col, Row, OverlayTrigger, Tooltip, Form, Badge } from 'react-bootstrap';
import Select from 'react-select';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import { setParcelDataError } from '../../../../slices/shipping/parcelDataSlice';

const ProductsPluginsCard = ({ product = {}, selectedItems = [], setSelectedItems = () => {} }) => {
  const { parcelData } = useSelector((state) => state.shipping_parcel);
  const dispatch = useDispatch();
  const [valueQuantity, setValueQuantity] = useState();

  const productIds = selectedItems?.map((item) => item.product_id);
  const isDisabled = product?.items_to_dispatch === 0;
  const optionsQuantity = [];
  for (let i = 1; i <= product?.items_to_dispatch; i += 1) {
    optionsQuantity.push({ value: i, label: i });
  }
  const updateSelectedItem = (productId, quantity) => {
    setSelectedItems((prev) => {
      const exists = prev.find((item) => item.product_id === productId);
      if (!exists) {
        return [...prev, { product_id: productId, quantity }];
      }
      return prev.map((item) => (item.product_id === productId ? { ...item, quantity } : item));
    });
  };

  const toggleItem = () => {
    // remove prev error
    if (parcelData?.errors?.products) {
      dispatch(setParcelDataError({ point: 'products', data: false }));
    }

    const exists = selectedItems.find((item) => item.product_id === product.product_id);
    if (exists) {
      // Si está, lo quitamos
      setSelectedItems(selectedItems.filter((x) => x.product_id !== product.product_id));
    } else {
      // Si no está, lo agregamos con cantidad 1 o la seleccionada
      updateSelectedItem(product.product_id, valueQuantity?.value || 1);
    }
  };
  useEffect(() => {
    const item = selectedItems?.find((i) => i.product_id === product?.product_id);
    if (item) {
      setValueQuantity({ value: item.quantity, label: item.quantity });
    } else {
      setValueQuantity(undefined); // O null, si prefieres limpiar
    }
  }, [selectedItems, product.product_id]);

  //
  return (
    <Card
      className={`h-auto mb-3 bg-background bg-primary ${productIds?.includes(product?.product_id) && 'selected'}`}
      style={{ boxShadow: '0 4px 16px rgba(var(--primary), 0.9)' }}
    >
      <Row
        className={`g-0 h-auto ${!isDisabled && 'cursor-pointer'}`}
        onClick={() => {
          if (!isDisabled) {
            toggleItem(product?.product_id);
          }
        }}
      >
        <Col
          xs="2"
          sm="1"
          className={`${isDisabled ? 'invisible' : 'visible'} d-flex justify-content-sm-end align-items-center ps-3 ps-sm-0 pt-5 order-1 bg-warningx`}
        >
          <Form.Check
            className="form-check"
            type="checkbox"
            checked={productIds.includes(product?.product_id)}
            onChange={() => {
              toggleItem();
            }}
          />
        </Col>
        <Col
          xs="10"
          sm="11"
          md="7"
          lg="10"
          xl="5"
          className="d-flex flex-column justify-content-center mb-3 mb-sm-2 ps-sm-3 ps-sm-2 ps-lg-0 pt-5 pe-2 order-2 bg-successx"
        >
          <div className="text-muted text-small">Producto</div>
          <div className="text-truncate">{product?.name}</div>
          {isDisabled && (
            <div>
              <Badge bg="outline-success">Enviado</Badge>
            </div>
          )}
        </Col>
        <Col xs="7" lg="8" xl="2" className="d-flex flex-column align-items-end mb-3 order-3 pt-xl-5 bg-secondaryx">
          <div className="text-muted text-small">Enviados</div>
          <div className="lh-1 text-alternate">{Number(product?.quantity || 0) - Number(product?.items_to_dispatch || 0)}</div>
        </Col>
        <Col xs="5" lg="4" className="d-flex flex-column align-items-end mb-3 pe-3 pt-xl-5 order-4 bg-infox">
          <div className="text-muted text-small text-end">Cantidad solicitada</div>
          <div className="lh-1 text-alternate">{product?.quantity}</div>
        </Col>
        <Col xs="12" className="d-flex flex-column justify-content-center align-items-end mb-3 pe-3 pt-lg-0 order-5 bg-successx">
          {product?.items_to_dispatch > 1 ? (
            <>
              <div className="text-muted text-small">Cantidad a enviar</div>
              <div onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()} onFocus={(e) => e.stopPropagation()}>
                <Select
                  classNamePrefix="react-select"
                  className="sw-9"
                  isSearchable={false}
                  options={optionsQuantity}
                  value={valueQuantity}
                  // onChange={setValueQuantity}
                  onChange={(selected) => {
                    setValueQuantity(selected);
                    updateSelectedItem(product?.product_id, selected?.value);
                  }}
                  placeholder="1"
                />
              </div>
            </>
          ) : (
            <></>
          )}
        </Col>
      </Row>
    </Card>
  );
};

export default ProductsPluginsCard;
